export class Paginator {
  constructor(initial, page_length, max) {
    this.initial = initial
    this.page = initial
    this.page_length = page_length
    this.max = max
  }

  beginning() {
    return this.page * this.page_length
  }

  end() {
    return Math.min((this.page * this.page_length) + this.page_length, this.max)
  }

  fewerPages() {
    return this.page > this.initial
  }

  morePages() {
    return ((this.page * this.page_length) + this.page_length) < this.max
  }

  paginate(num) {
    this.page += num
  }

  reset() {
    this.page = this.initial
  }

  setMax(max) {
    this.max = max
  }
}
